export default __webpack_public_path__ + "static/media/shard_of_a_foul_legacy.01112705.png";